import {
  FETCH_WORKFLOW_CONFIG,
  FETCH_WORKFLOW_CONFIG_SUCCESS,
  FETCH_WORKFLOW_CONFIG_FAIL,
  SAVE_WORKFLOW_CONFIG,
  SAVE_WORKFLOW_CONFIG_SUCCESS,
  SAVE_WORKFLOW_CONFIG_FAIL,
  FETCH_ORDER_TRANSITIONS,
  FETCH_ORDER_TRANSITIONS_SUCCESS,
  FETCH_ORDER_TRANSITIONS_FAIL,
  EXECUTE_ORDER_TRANSITION,
  EXECUTE_ORDER_TRANSITION_SUCCESS,
  EXECUTE_ORDER_TRANSITION_FAIL,
  CLEAR_WORKFLOW_ERROR,
} from "./actionTypes"

// Workflow Config
export const fetchWorkflowConfig = () => ({
  type: FETCH_WORKFLOW_CONFIG,
})

export const fetchWorkflowConfigSuccess = (config) => ({
  type: FETCH_WORKFLOW_CONFIG_SUCCESS,
  payload: config,
})

export const fetchWorkflowConfigFail = (error) => ({
  type: FETCH_WORKFLOW_CONFIG_FAIL,
  payload: error,
})

export const saveWorkflowConfig = (templateId, config) => ({
  type: SAVE_WORKFLOW_CONFIG,
  payload: { templateId, config },
})

export const saveWorkflowConfigSuccess = (config) => ({
  type: SAVE_WORKFLOW_CONFIG_SUCCESS,
  payload: config,
})

export const saveWorkflowConfigFail = (error) => ({
  type: SAVE_WORKFLOW_CONFIG_FAIL,
  payload: error,
})

// Order Transitions
export const fetchOrderTransitions = (orderId) => ({
  type: FETCH_ORDER_TRANSITIONS,
  payload: orderId,
})

export const fetchOrderTransitionsSuccess = (transitions) => ({
  type: FETCH_ORDER_TRANSITIONS_SUCCESS,
  payload: transitions,
})

export const fetchOrderTransitionsFail = (error) => ({
  type: FETCH_ORDER_TRANSITIONS_FAIL,
  payload: error,
})

export const executeOrderTransition = (orderId, transitionId, options = {}) => ({
  type: EXECUTE_ORDER_TRANSITION,
  payload: { orderId, transitionId, options },
})

export const executeOrderTransitionSuccess = (result) => ({
  type: EXECUTE_ORDER_TRANSITION_SUCCESS,
  payload: result,
})

export const executeOrderTransitionFail = (error) => ({
  type: EXECUTE_ORDER_TRANSITION_FAIL,
  payload: error,
})

export const clearWorkflowError = () => ({
  type: CLEAR_WORKFLOW_ERROR,
})
